import { c as _c } from "react/compiler-runtime";
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';

/**
 * True below the `md` breakpoint (first two Chakra sizes: base + sm).
 * Replaces repeated `getBreakpointValue([true, true, false, false, false])`.
 */
export function useIsMobile() {
  const $ = _c(2);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return !!t0;
}